import React from 'react';
import { Helmet } from "react-helmet-async";
import './AboutSection.css';
import AboutImg from './images/pexels-negativespace-160107.jpg';

const AboutUs = ({ isDarkMode }) => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Corporation',
    'name': 'AstraSight Technologies',
    'url': 'https://astrasighttech.com',
    'logo': 'https://astrasighttech.com/images/asighticon1.png',
    'description': 'AstraSight Technologies specializes in web development, app development, software solutions, cybersecurity, and digital marketing for businesses across Africa.',
    'contactPoint': {
      '@type': 'ContactPoint',
      'telephone': '+254791865638',
      'contactType': 'customer service',
      'areaServed': 'KE',
      'availableLanguage': ['English']
    },
    'address': {
      '@type': 'PostalAddress',
      'streetAddress': 'Nairobi, Kenya',
      'addressLocality': 'Nairobi',
      'addressCountry': 'KE'
    }
  };

  return (
    <>
      <Helmet>
        <title>About AstraSight Technologies - Digital Solutions in Kenya & Africa</title>
        <meta name="description" content="AstraSight Technologies, based in Nairobi, Kenya, provides web development, software solutions, cybersecurity, branding, and digital marketing to businesses across Africa." />
        <meta name="keywords" content="web development, software solutions, cybersecurity, digital marketing, AstraSight Technologies, IT solutions Kenya, IT solutions Africa" />
        <meta name="author" content="AstraSight Technologies" />
        <meta property="og:title" content="About AstraSight Technologies - Digital Solutions in Kenya & Africa" />
        <meta property="og:description" content="Learn about AstraSight Technologies and how we help businesses in Kenya and across Africa thrive with modern digital solutions." />
        <meta property="og:image" content="https://astrasighttech.com/about-banner.png" />
        <meta property="og:url" content="https://astrasighttech.com/about" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <section className={`about-us ${isDarkMode ? 'dark' : 'light'}`}>
        <div className="about-us-content">
          <div className="about-text">
            <h2>About AstraSight Technologies – Kenya’s Digital Growth Partner</h2>
            <p>
              Based in <strong>Nairobi, Kenya</strong>, AstraSight Technologies provides <strong>web development, app development, software solutions, cybersecurity, branding, and digital marketing</strong> to businesses across Africa.
            </p>
            <p>
              Our mission is to empower African businesses with <strong>secure, scalable, and high-performance digital solutions.</strong>
              Whether you're a startup or a large enterprise, we turn ideas into powerful online experiences that drive success.
            </p>
            <p>
              💡 <strong>Why Choose AstraSight Technologies?</strong>
              <ul>
                <li>🚀 Cutting-edge IT solutions tailored for businesses in Kenya and Africa</li>
                <li>🔒 Strong cybersecurity to protect your digital assets</li>
                <li>🌍 Digital marketing strategies that boost brand visibility</li>
              </ul>
            </p>
            <p>
              Partner with AstraSight Technologies today and take your business to the next level!
            </p>
          </div>
          <div className="about-image">
            <img 
              src={AboutImg} 
              alt="AstraSight Technologies - Leading Digital Solutions Provider in Kenya and Africa" 
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;
